import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { SignUpModel, UserProfile } from '../../models/user';
import { Role } from '../../models/user-management/role';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserItemModel } from '../../models/user/user-item-model';
import { environment } from '../../../../environments/environment';
import { DataModel } from '../../models/user-management/data-model';
import { Jurisdiction } from 'src/app/core/models/user/jurisdiction';
import { ItemIdModel } from '../../models/filter-model/item-id-model';
import { HelpModel } from './../../models/user-management/help-model';
import { RoleScreen } from '../../models/user-management/role-screen';
import { UserRegulators } from '../../models/regulation/user-regulators';
import { JurisdictionModel } from '../../models/user/jurisdiction-model';
import { FilterItems } from './../../models/user-management/filter-items';
import { AuditTrailDto } from './../../models/view-model/audit-trail-dto';
import { UserInfoData } from '../../models/user-management/user-info-data';
import { ManageRoleModel } from '../../models/user-management/manage-roles';
import { RegulatorMaster } from './../../models/regulation/regulator-master';
import { AuditTrailModel } from './../../models/view-model/audit-trail-model';
import { UpdatePubType } from './../../models/user-management/update-pub-type';
import { PlanTypeAction } from './../../models/user-management/plan-type-action';
import { RegulatorPubTypeModel } from '../../models/user-management/pub-type-model';
import { DownloadReportModel } from '../../models/view-model/download-report-model';
import { ScreenActionModel } from '../../models/user-management/screen-action-model';
import { AssignedRoleDto } from './../../models/user-management/assigned-role-model';
import { UserLicensedModel } from '../../models/user-management/user-licensed-model';
import { ParentChildItemModel } from '../../models/filter-model/parent-child-item-model';
import { AuditTrailMasterFilter } from '../../models/user-management/audit-trail-master-filter';
import { UserDetailModel, UserInfoFilterModel } from './../../models/user-management/user-filter-model';
import { ThemeModel } from '../../models/user-management/theme-model';
import { ThemeGetModel } from '../../models/user-management/get-theme-details-model';
import { FileType } from '../../enums/user/file-type';
import { catchError } from 'rxjs/operators';
import { UserInfoForJurisdictinUpdate } from '../../models/user/user-info-for-jurisdictin-update';
import { impactAssessmentTemplateDetails, selfTemplateDetails } from '../../models/self-assessment/template';
import { TemplateDetails } from '../../models/impact-assessment/template-details-model';
import { JurisdictionsList } from '../../models/impact-assessment/jurisdictions-list-model';

@Injectable({ providedIn: 'root' })
export class UserManagementService {


  constructor(private http: HttpClient) {
  }

  getRoleScreenList(): Observable<ManageRoleModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<ManageRoleModel>(`${environment.config.baseAppURL}/UserManagement/GetManageRolesData`, { headers });
  }

  getRoleScreens(): Observable<RoleScreen[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<RoleScreen[]>(`${environment.config.baseAppURL}/UserManagement/GetRoleScreen`, { headers });
  }

  getRoles(): Observable<Role[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Role[]>(`${environment.config.baseAppURL}/UserManagement/GetRoles`, { headers });
  }

  updateRoleScreen(roleId: number, screenId: number, parentId: number, status: boolean): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    const dataObject = { RoleId: roleId, ScreenId: screenId, ParentId: parentId, Status: status };
    return this.http.post<any>(`${environment.config.baseAppURL}/UserManagement/UpdateRoleScreen`, dataObject, { headers });
  }

  getAllUsers(filters: UserInfoFilterModel): Observable<UserInfoData> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filters));
    return this.http.get<UserInfoData>(`${environment.config.baseAppURL}/UserManagement/GetAllUsers`, { headers });
  }

  getAllUsersListForAllRole(filters: UserInfoFilterModel): Observable<UserInfoData> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filters));
    return this.http.get<UserInfoData>(`${environment.config.baseAppURL}/UserManagement/GetAllUsersListForAllRole`, { headers });
  }

  updateUserInfo(userInfo: AssignedRoleDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(`${environment.config.baseAppURL}/UserManagement/UpdateUser`, userInfo, { headers });
  }

  deleteUserInfo(userInfo: AssignedRoleDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/UserManagement/DeleteUser`, userInfo, { headers });
  }

  registerUser(user: SignUpModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(user));
    return this.http.get<any>(`${environment.config.baseAppURL}/UserManagement/SignUp`, { headers });
  }

  getRegulators(): Observable<RegulatorMaster[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<RegulatorMaster[]>(`${environment.config.baseAppURL}/UserRegulationManagement/GetAllRegulators`, { headers });
  }

  updateUserRegulators(resultData: UserItemModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(`${environment.config.baseAppURL}/UserManagement/UpdateUserRegulators`, resultData, { headers });
  }

  saveNewRole(role: Role): Observable<UserRegulators[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<UserRegulators[]>(`${environment.config.baseAppURL}/UserManagement/AddNewRole`, role, { headers });
  }

  deleteRole(roleId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/UserManagement/DeleteRole?id=` + roleId, { headers });
  }

  downloadUserTemplate(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(`${environment.config.baseAppURL}/UserManagement/DownloadUserTemplate`, { headers, responseType: 'blob' });
  }

  postFile(fileToUpload: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Bearer ');
    return this.http.post<any>(`${environment.config.baseAppURL}/UserManagement/UploadBulkUser`, formData, { headers });
  }

  getScreenByRole(roleId: number): Observable<DataModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<DataModel[]>(`${environment.config.baseAppURL}/UserManagement/GetScreenByRole?roleId=`
      + roleId, { headers });
  }

  getAuditTrail(auditTrailDto: AuditTrailDto): Observable<AuditTrailModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(auditTrailDto));
    // tslint:disable-next-line:max-line-length
    return this.http.get<AuditTrailModel>(`${environment.config.baseAppURL}/UserManagement/GetAuditTrail`, { headers });
  }

  getAuditTrailFilters(auditTrailDto: AuditTrailDto): Observable<AuditTrailMasterFilter> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(auditTrailDto));
    return this.http.get<AuditTrailMasterFilter>(`${environment.config.baseAppURL}/UserManagement/GetAuditTrailFiltersData`,
      { headers });
  }

  getHelpData(): Observable<HelpModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<HelpModel>(`${environment.config.baseAppURL}/UserManagement/GetHelpData`, { headers });
  }

  getScreenActionData(): Observable<ScreenActionModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<ScreenActionModel>(`${environment.config.baseAppURL}/UserManagement/GetScreenActionData`, { headers });
  }

  updateScreenAction(obj: PlanTypeAction): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/UserManagement/UpdateScreenAction`, obj, { headers });
  }

  getPlanTypeAction(): Observable<Array<PlanTypeAction>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<PlanTypeAction>>(`${environment.config.baseAppURL}/UserManagement/GetPlanTypeAction`, { headers });
  }

  addJurisdictions(obj: Jurisdiction): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/UserManagement/CreateNewJurisdiction`, obj, { headers });
  }

  getJurisdictions(userId: number): Observable<JurisdictionModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<JurisdictionModel>(`${environment.config.baseAppURL}/UserManagement/GetJurisdictions?id=` + userId, { headers });
  }

  updateUserJurisdictions(resultData: UserItemModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(`${environment.config.baseAppURL}/UserManagement/UpdateJurisdiction`, resultData, { headers });
  }

  getUserJurisdictions(): Observable<Array<ItemIdModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<ItemIdModel>>(`${environment.config.baseAppURL}/UserManagement/GetUserJurisdictions`,
      { headers });
  }

  getAllJurisdictions(): Observable<Array<ItemIdModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<ItemIdModel>>(`${environment.config.baseAppURL}/UserManagement/GetAllJurisdictions`,
      { headers });
  }

  getPubTypes(jurisId: number, id: number): Observable<RegulatorPubTypeModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<RegulatorPubTypeModel>(`${environment.config.baseAppURL}/UserManagement/GetPubTypes?jId=` + jurisId
      + '&id=' + id, { headers });
  }

  updatePubType(obj: UpdatePubType[], userDivision:string | null,userREgulator:string | null): Observable<any> {
    let headers = new HttpHeaders();
    // obj[0].pubType = this.remove_non_ascii(obj[0].pubType)
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/UserManagement/UpdatePubType?userDivision=`+ userDivision+`&userREgulator=`+userREgulator, obj, { headers });
  }
  remove_non_ascii(str: string) {
    if ((str === null) || (str === '')) return false; else str = str.toString(); return str.replace(/[^\x20-\x7E]/g, '');
  }

  getUserName(id: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/UserManagement/GetUserName?id=` + id, { headers });
  }

  getUserDetails(): Observable<UserDetailModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<UserDetailModel>(`${environment.config.baseAppURL}/UserManagement/GetUserDetails`, { headers });
  }

  saveJurisdictionsRegulator(obj: DownloadReportModel, userDivision: string | null): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(obj));
    return this.http.get<any>(`${environment.config.baseAppURL}/UserManagement/SaveJurisdictionRegulator?userDivision=` + userDivision, { headers });
  }

  getJurisdictionsRegulator(id: number): Observable<Array<ParentChildItemModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<ParentChildItemModel>>(`${environment.config.baseAppURL}/UserManagement/GetJurisdictionRegulator?id=`
      + id, { headers });
  }

  exportUserReport(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(`${environment.config.baseAppURL}/UserManagement/DownloadUserReport`, { headers, responseType: 'blob' });
  }

  getLicensedDetails(): Observable<UserLicensedModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<UserLicensedModel>(`${environment.config.baseAppURL}/UserManagement/GetLicensedInfo`, { headers });
  }

  exportAuditTrail(filterObj: AuditTrailDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filterObj));
    return this.http.get(`${environment.config.baseAppURL}/UserManagement/DownloadAuditReport`, { headers, responseType: 'blob' });
  }

  exportUserRegulatorReport(ids: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(`${environment.config.baseAppURL}/UserManagement/DownloadUserReguratorReport?ids=`
      + ids, { headers, responseType: 'blob' });
  }

  generateJoseJWT(page:string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(`${environment.config.baseAppURL}/UserManagement/GenerateJoseJWT?page=`+page, { headers });
  }

  addTheme(selectedTheme: any, isDefault:boolean): Observable<any> {
    const headers = new HttpHeaders();
    return this.http.post<any>(`${environment.config.baseAppURL}/UserManagement/AddTheme?isDefault=`+isDefault, selectedTheme, { headers });
  }
  getThemeDetails(): Observable<ThemeGetModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<ThemeGetModel>(`${environment.config.baseAppURL}/UserManagement/GetThemeDetails`, { headers }).pipe(
      catchError((error: any) => {
        // Handle the error here, log it, and return a meaningful error message
        console.error('Error fetching theme details:', error);
        return throwError('An error occurred while fetching theme details.');
      })
    );;
  }
  // getThemeDetails(): Observable<string> {
  //   return this.http.get<string>(`${environment.config.baseAppURL}/UserManagement/GetThemeDetails`);
  // }
  uploadEvidence(
    fileToUpload: File
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    const headers = new HttpHeaders();
    return this.http.post<any>(
      `${environment.config.baseAppURL}/UserManagement/AddTheme`,
      formData,
      { headers }
    );
  }
   updateUserProfileJurisdictions(resultData: UserInfoForJurisdictinUpdate): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(`${environment.config.baseAppURL}/UserManagement/UpdateUserProfileJurisdiction`, resultData, { headers });
  }
  updateSelfTemplateNo(obj: selfTemplateDetails): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/UserManagement/UpdateSelfTemplate`, obj,{ headers });
  }
  updateImpactTemplateNo(obj: impactAssessmentTemplateDetails): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/UserManagement/UpdateImpactTemplate`,obj, { headers });
  }
  getTemplateDetails(jurisdiction:number): Observable<TemplateDetails> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<TemplateDetails>(`${environment.config.baseAppURL}/UserManagement/GetTemplateDetails?jurisdictionId=`+jurisdiction, { headers });
  }

  GetCkEditorKey(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/UserManagement/GetCkEditorKey`, { headers });
  }
  getJurisdictionName(jurisdictionId: number): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<string>(`${environment.config.baseAppURL}/UserManagement/GetJurisdictionName?jurisdictionId=` + jurisdictionId, { headers });
  }
  generateClusterJoseJWT(updateId:number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(`${environment.config.baseAppURL}/UserManagement/GenerateClusterJoseJWT?updateId=`+updateId, { headers });
  }
  GetJurisdictionsList(): Observable<JurisdictionsList> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<JurisdictionsList>(`${environment.config.baseAppURL}/UserManagement/GetJurisdictionsList`, { headers });
  }

  
}
